import { isSSR, tariffClickYM, ymPushEvent, ymPushParams } from '@fttb/common/utils';
import { TARIFF_TYPES } from '@fttb/common';
import { CONVERGENT_CONNECT_UP_FORM, HOME_TARIFF_CONNECT_LONG_FORM } from "./constants";
export var ymOrderTariffIsOpen = function ymOrderTariffIsOpen(tariffData) {
  if (isSSR()) return;
  var formType = tariffData.isPopular ? 'top_tariff' : 'tariff_cart';
  if (tariffData.tariffType === TARIFF_TYPES.internet || tariffData.tariffType === TARIFF_TYPES.kit) {
    ymPushParams({
      fttb_ev_: {
        full_form_request_sent: tariffData.tariffAlias
      }
    });
    ymPushEvent(HOME_TARIFF_CONNECT_LONG_FORM, {
      URL: window.location.href,
      form_type: formType,
      tariff: tariffData.tariffAlias
    });
    return;
  }
  if (tariffData.tariffType === TARIFF_TYPES.presetUp) {
    ymPushParams({
      fmc_ev_: {
        fmc_request_start: tariffData.tariffAlias
      }
    });
    ymPushEvent(CONVERGENT_CONNECT_UP_FORM, {
      URL: window.location.href,
      form_type: formType,
      tariff: tariffData.tariffAlias
    });
    return;
  }
  tariffClickYM();
};
export var ymOrderTariffAddressView = function ymOrderTariffAddressView(payload, tariffType) {
  if (tariffType === TARIFF_TYPES.presetUp) {
    ymPushParams({
      fmc_ev_: {
        fmc_address_check: payload
      }
    });
  } else {
    ymPushParams({
      fttb_ev_: {
        full_form_address: payload
      }
    });
  }
};
export var ymOrderAlternativeTariffView = function ymOrderAlternativeTariffView(payload) {
  if (isSSR()) return;
  ymPushParams({
    fttb_ev_: {
      full_form_tariff_details: payload
    }
  });
  ymPushEvent('HomeTariffCallbackLongForm', {
    URL: window.location.href,
    form_type: 'operator'
  });
};
export var ymOrderTariffDetailsView = function ymOrderTariffDetailsView(payload) {
  ymPushParams({
    fttb_ev_: {
      full_form_bid: payload
    }
  });
};
export var ymOrderTariffCalendarView = function ymOrderTariffCalendarView(payload) {
  ymPushParams({
    fttb_ev_: {
      full_form_visit: payload
    }
  });
};
export var ymCheckConnectionTariffUp = function ymCheckConnectionTariffUp(payload) {
  ymPushParams({
    fmc_ev_: {
      fmc_tariff_check: payload
    }
  });
};